import { render, staticRenderFns } from "./PosReportCustomer.vue?vue&type=template&id=786ac01d&"
import script from "./PosReportCustomer.vue?vue&type=script&lang=js&"
export * from "./PosReportCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports